module.exports = __webpack_public_path__ + "static/media/6.975bc75b.svg";